import { Link } from "react-router-dom";
import { components, learningPath, getLevel, stages } from "../data/competencyData";
import { loadCurrent } from "../data/diagnosticsStore";
import GrowthPlan from "../components/GrowthPlan";
import { completedCount } from "../data/modulesStore";
import { studentModules } from "../data/studentModules";

function Students() {
    const current = loadCurrent();
    const modulesDone = completedCount();

    return (
        <>
            <section className="page-header">
                <div className="container">
                    <div className="page-header__content">
                        <ul className="eduhive-breadcrumb list-unstyled">
                            <li><span className="eduhive-breadcrumb__icon"><i className="icon-home"></i></span><Link to="/">Bosh sahifa</Link></li>
                            <li><span>Talabalar uchun</span></li>
                        </ul>
                        <h2 className="page-header__title">Bo'lajak tarbiyachilar uchun</h2>
                    </div>
                </div>
            </section>

            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Kasbiy-metodik kompetensiyangizni rivojlantiring</h3>
                                <p className="pricing-one__text">
                                    Ushbu bo'lim maktabgacha ta'lim yo'nalishi talabalari uchun. O'quv yo'li kirish diagnostikasidan boshlanadi,
                                    zamonaviy metodlar va xorij tajribasini o'rganish bilan davom etadi va chiqish diagnostikasi bilan yakunlanadi.
                                </p>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5">
                            {current && (
                                <div style={{ background: "#fff8e6", border: "1px solid #ffe2a1", borderRadius: 12, padding: 20, marginBottom: 30 }}>
                                    <strong>{current.name}</strong>{current.group ? ` · ${current.group}` : ""}
                                    <div className="d-flex mt-2" style={{ gap: 24, flexWrap: "wrap" }}>
                                        {Object.keys(stages).map((s) => (
                                            <span key={s}>
                                                {stages[s].label}:{" "}
                                                {current[s] ? (
                                                    <strong style={{ color: getLevel(current[s].overall).color }}>
                                                        {current[s].overall}% ({getLevel(current[s].overall).label})
                                                    </strong>
                                                ) : (
                                                    <span style={{ color: "#999" }}>topshirilmagan</span>
                                                )}
                                            </span>
                                        ))}
                                        {current.pre && current.post && (
                                            <span>O'sish: <strong>{current.post.overall - current.pre.overall > 0 ? "+" : ""}{current.post.overall - current.pre.overall}%</strong></span>
                                        )}
                                    </div>
                                </div>
                            )}
                            {current && (current.post || current.pre) && (
                                <div style={{ marginBottom: 40 }}>
                                    <GrowthPlan scores={(current.post || current.pre).scores} />
                                </div>
                            )}

                            <h4 className="mb-4">O'quv yo'li</h4>
                            <div className="row gutter-y-30">
                                {learningPath.map((p) => {
                                    const done = p.key === "modules"
                                        ? modulesDone === studentModules.length
                                        : p.key && current && current[p.key];
                                    return (
                                        <div className="col-md-6 col-lg-3" key={p.step}>
                                            <Link to={p.path} style={{ display: "block", height: "100%", color: "inherit" }}>
                                                <div className="pricing-one__card" style={{ height: "100%", position: "relative" }}>
                                                    <div style={{
                                                        width: 44, height: 44, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
                                                        background: done ? "#10b981" : "#ffb606", color: "#fff", fontWeight: 700, fontSize: 18, marginBottom: 14
                                                    }}>
                                                        {done ? <i className="icon-check"></i> : p.step}
                                                    </div>
                                                    <h3 className="pricing-one__card__title" style={{ fontSize: 20 }}>{p.title}</h3>
                                                    <p className="pricing-one__card__text" style={{ marginBottom: 0 }}>{p.text}</p>
                                                    {p.key === "modules" && (
                                                        <p style={{ margin: "8px 0 0", fontSize: 14, color: "#10b981", fontWeight: 600 }}>Bajarildi: {modulesDone} / {studentModules.length}</p>
                                                    )}
                                                </div>
                                            </Link>
                                        </div>
                                    );
                                })}
                            </div>

                            <h4 className="mt-5 mb-3">Kasbiy-metodik kompetensiya tuzilmasi</h4>
                            <p style={{ color: "#666" }}>
                                Diagnostika quyidagi to'rt komponent bo'yicha o'tkaziladi va har biri uchun past, o'rta yoki yuqori daraja aniqlanadi.
                            </p>
                            <div className="row gutter-y-20 pb-5">
                                {components.map((c) => (
                                    <div className="col-md-6" key={c.id}>
                                        <div style={{ background: "#fafafa", borderRadius: 12, padding: 20, height: "100%", borderLeft: "4px solid #ffb606" }}>
                                            <div className="d-flex align-items-center" style={{ gap: 10, marginBottom: 8 }}>
                                                <i className={c.icon} style={{ color: "#ffb606", fontSize: 20 }}></i>
                                                <strong>{c.title}</strong>
                                            </div>
                                            <p style={{ margin: 0, color: "#666" }}>{c.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Students;
